import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetTags(params) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/tag`,
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAssignableTags(params) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/tag/assignable`,
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateTag(tagData) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/tag`,
        data: tagData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateTag(tagId, tagData) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/tag/${tagId}`,
        data: tagData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteTag(tagId) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/tag/${tagId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreTag(tagId) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/tag/${tagId}/restore`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTagUsage(tagId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/tag/${tagId}/usage`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetTagAssignments(targetType, targetId, assignments) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/tag/assignments/${targetType}/${targetId}`,
        data: assignments,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetInheritedTags(params) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/tag/inherited`,
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTagDetail(tagId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/tag/${tagId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateTagContext(tagId, context) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/tag/${tagId}/context`,
        data: { context },
        withCredentials: true,
        crossorigin: true,
    });
}
